"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutConfig = void 0;
const helpers_1 = require("../../shared/helpers");
const getLayoutConfig = (stimulus, translations, mediaAssets, trialNumber) => {
    const { answer, distractors, trialType } = stimulus;
    const defaultConfig = JSON.parse(JSON.stringify(helpers_1.DEFAULT_LAYOUT_CONFIG));
    const stimItem = (0, helpers_1.convertItemToString)(stimulus.item);
    defaultConfig.isPracticeTrial = stimulus.assessmentStage === 'practice_response';
    defaultConfig.isInstructionTrial = stimulus.trialType === 'instructions';
    defaultConfig.showStimImage = stimulus.trialType === 'instructions' || stimulus.trialType.includes('Counting');
    defaultConfig.stimText = {
        value: stimItem,
        displayValue: undefined,
    };
    defaultConfig.inCorrectTrialConfig.onIncorrectTrial = 'skip';
    if (!defaultConfig.isInstructionTrial) {
        const mappedDistractors = (0, helpers_1.mapDistractorsToString)(distractors);
        const prepChoices = trialType === 'Counting'
            ? (0, helpers_1.prepareChoices)(answer.toString(), mappedDistractors, 'no', trialType)
            : (0, helpers_1.prepareChoices)(answer.toString(), mappedDistractors, 'yes', trialType);
        defaultConfig.prompt.enabled = false;
        defaultConfig.isImageButtonResponse =
            trialType === 'Non-symbolic Number Identification' || trialType === 'Non-symbolic Number Comparison';
        defaultConfig.classOverrides.buttonClassList =
            trialType === 'Non-symbolic Number Identification' || trialType === 'Non-symbolic Number Comparison'
                ? ['image-medium']
                : trialType === 'Counting'
                    ? ['primary']
                    : ['secondary'];
        defaultConfig.response = {
            target: prepChoices.target,
            displayValues: prepChoices.choices,
            values: prepChoices.originalChoices,
            targetIndex: prepChoices.correctResponseIdx,
        };
        if (!['Number Identification', 'Number Comparison', 'Counting', 'Counting AFC'].includes(stimulus.trialType)) {
            defaultConfig.stimText = {
                value: stimItem,
                displayValue: stimulus.trialType === 'Fraction' ? (0, helpers_1.fractionToMathML)(stimItem) : stimItem,
            };
        }
    }
    else {
        defaultConfig.classOverrides.buttonClassList = ['primary'];
        stimulus.trialType === 'instructions'
            ? (defaultConfig.classOverrides.stimulusContainerClassList = ['lev-instructions-container'])
            : (defaultConfig.classOverrides.stimulusContainerClassList = ['lev-row-container']);
    }
    const messages = (0, helpers_1.validateLayoutConfig)(defaultConfig, mediaAssets, translations, stimulus);
    return {
        itemConfig: defaultConfig,
        errorMessages: messages,
    };
};
exports.getLayoutConfig = getLayoutConfig;
